import React, { useState } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  useColorScheme,
  TextInput,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const FoodHomeScreen = ({ navigation }) => {
  const isDarkMode = useColorScheme() === 'dark';
  const [searchText, setSearchText] = useState('');

  const handleSearch = () => {
    if (searchText.trim()) {
      navigation.navigate('FoodSearch', { searchQuery: searchText });
    }
  };

  const categories = [
    { name: '谷物类', icon: 'nutrition', color: '#f59e0b' },
    { name: '蔬菜类', icon: 'leaf', color: '#84cc16' },
    { name: '水果类', icon: 'cafe', color: '#ec4899' },
    { name: '肉类', icon: 'restaurant', color: '#ef4444' },
    { name: '海鲜类', icon: 'fish', color: '#06b6d4' },
    { name: '乳制品', icon: 'water', color: '#3b82f6' },
    { name: '油脂类', icon: 'flask', color: '#f97316' },
    { name: '零食饮料', icon: 'ice-cream', color: '#8b5cf6' },
  ];

  return (
    <ScrollView 
      style={{
        flex: 1,
        backgroundColor: isDarkMode ? '#8fa0c1' : '#ffffff',
      }}
      contentContainerStyle={{ padding: 16 }}
    >
      {/* 搜索框 */}
      <View style={{
        flexDirection: 'row',
        marginBottom: 16,
        backgroundColor: isDarkMode ? '#a9b6d0' : '#f3f4f6',
        borderRadius: 12,
        padding: 4,
        alignItems: 'center',
      }}>
        <TextInput
          style={{
            flex: 1,
            paddingVertical: 12,
            paddingHorizontal: 16,
            fontSize: 16,
            color: isDarkMode ? 'white' : '#1f2937',
          }}
          placeholder="搜索食物（支持拼音/关键词）"
          placeholderTextColor={isDarkMode ? '#e0e0e0' : '#9ca3af'}
          value={searchText}
          onChangeText={setSearchText}
          returnKeyType="search"
          onSubmitEditing={handleSearch}
        />
        <TouchableOpacity
          onPress={handleSearch}
          style={{
            padding: 12,
            borderRadius: 8,
            backgroundColor: '#2563eb',
            marginRight: 4,
          }}
        >
          <Ionicons name="search" size={24} color="white" />
        </TouchableOpacity>
      </View>

      {/* 快捷功能 */}
      <View style={{
        flexDirection: 'row',
        marginBottom: 24,
        justifyContent: 'space-between',
      }}>
        <TouchableOpacity
          style={{
            flex: 1,
            marginRight: 8,
            padding: 16,
            borderRadius: 12,
            backgroundColor: isDarkMode ? '#a9b6d0' : 'white',
            alignItems: 'center',
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
            elevation: 2,
          }}
          onPress={() => navigation.navigate('FoodInputHome')}
        >
          <Ionicons name="scan" size={28} color="#8b5cf6" />
          <Text style={{
            marginTop: 8,
            fontSize: 16,
            fontWeight: '500',
            color: isDarkMode ? 'white' : '#1f2937',
          }}>智能录入</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={{
            flex: 1,
            marginHorizontal: 8,
            padding: 16,
            borderRadius: 12,
            backgroundColor: isDarkMode ? '#a9b6d0' : 'white',
            alignItems: 'center',
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
            elevation: 2,
          }}
          onPress={() => navigation.navigate('FoodFavorites', { tab: 'recent' })}
        >
          <Ionicons name="time" size={28} color="#3b82f6" />
          <Text style={{
            marginTop: 8,
            fontSize: 16,
            fontWeight: '500',
            color: isDarkMode ? 'white' : '#1f2937',
          }}>最近使用</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={{
            flex: 1,
            marginLeft: 8,
            padding: 16,
            borderRadius: 12,
            backgroundColor: isDarkMode ? '#a9b6d0' : 'white',
            alignItems: 'center',
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
            elevation: 2,
          }}
          onPress={() => navigation.navigate('FoodFavorites', { tab: 'favorites' })}
        >
          <Ionicons name="heart" size={28} color="#ec4899" />
          <Text style={{
            marginTop: 8,
            fontSize: 16,
            fontWeight: '500',
            color: isDarkMode ? 'white' : '#1f2937',
          }}>我的收藏</Text>
        </TouchableOpacity>
      </View>

      {/* 食物分类 */}
      <View style={{ marginBottom: 24 }}>
        <Text style={{
          fontSize: 18,
          fontWeight: 'bold',
          marginBottom: 16,
          color: isDarkMode ? 'white' : '#1f2937',
        }}>
          食物分类
        </Text>

        <View style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}>
          {categories.map((category) => (
            <TouchableOpacity
              key={category.name}
              style={{
                width: '23%',
                marginBottom: 16,
                alignItems: 'center',
              }}
              onPress={() => navigation.navigate('FoodSearch', { category: category.name })}
            >
              <View style={{
                width: 56,
                height: 56,
                borderRadius: 28,
                backgroundColor: category.color,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 8,
              }}>
                <Ionicons name={category.icon} size={28} color="white" />
              </View>
              <Text style={{
                fontSize: 14,
                color: isDarkMode ? 'white' : '#1f2937',
                textAlign: 'center',
              }}>
                {category.name}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      </View>

      {/* 营养目标 */}
      <TouchableOpacity
        style={{
          padding: 16,
          borderRadius: 12,
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: 24,
        }}
        onPress={() => navigation.navigate('PersonalNutrition')}
      >
        <View style={{
          width: 50,
          height: 50,
          borderRadius: 25,
          backgroundColor: '#2563eb',
          justifyContent: 'center',
          alignItems: 'center',
          marginRight: 16,
        }}>
          <Ionicons name="analytics" size={28} color="white" />
        </View>
        <View style={{ flex: 1 }}>
          <Text style={{
            fontSize: 16,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 4,
          }}>
            个人营养目标
          </Text>
          <Text style={{
            fontSize: 14,
            color: isDarkMode ? '#e0e0e0' : '#6b7280',
          }}>
            设置您的营养目标，获取个性化推荐
          </Text>
        </View>
        <Ionicons name="chevron-forward" size={24} color={isDarkMode ? 'white' : '#9ca3af'} />
      </TouchableOpacity>

      {/* 自定义食物库 */}
      <TouchableOpacity
        style={{
          padding: 16,
          borderRadius: 12,
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          flexDirection: 'row',
          alignItems: 'center',
        }}
        onPress={() => navigation.navigate('FoodFavorites', { tab: 'custom' })}
      >
        <View style={{
          width: 50,
          height: 50,
          borderRadius: 25,
          backgroundColor: '#0d9488',
          justifyContent: 'center',
          alignItems: 'center',
          marginRight: 16,
        }}>
          <Ionicons name="add-circle" size={28} color="white" />
        </View>
        <View style={{ flex: 1 }}>
          <Text style={{
            fontSize: 16,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 4,
          }}>
            自定义食物库
          </Text>
          <Text style={{
            fontSize: 14,
            color: isDarkMode ? '#e0e0e0' : '#6b7280',
          }}>
            添加和管理您的自定义食物
          </Text>
        </View>
        <Ionicons name="chevron-forward" size={24} color={isDarkMode ? 'white' : '#9ca3af'} />
      </TouchableOpacity>
    </ScrollView>
  );
};

export default FoodHomeScreen; 